var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.55556 0 0 3.55556 0 8C0 12.4444 3.55556 16 8 16C12.4444 16 16 12.4444 16 8C16 3.55556 12.3704 0 8 0ZM8 14.8148C4.22222 14.8148 1.18519 11.7778 1.18519 8C1.18519 4.22222 4.22222 1.18519 8 1.18519C11.7778 1.18519 14.8148 4.14815 14.8148 8C14.8148 11.8519 11.7778 14.8148 8 14.8148Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85577 3.86965C8.186 3.64639 7.44181 3.64639 6.69763 4.01849C6.02786 4.31616 5.58135 4.91151 5.28367 5.58128C5.20926 5.87895 5.35809 6.17662 5.65577 6.32546C5.95344 6.39988 6.25112 6.25104 6.32553 5.95337C6.47437 5.50686 6.77205 5.20918 7.14414 4.98593C7.51623 4.76267 8.03716 4.76267 8.40926 4.91151C9.07902 5.13476 9.52553 5.80453 9.52553 6.4743C9.52553 7.51616 7.66507 8.18593 7.66507 8.18593C7.44181 8.33476 7.29298 8.63244 7.44181 8.93011C7.51623 9.15337 7.73949 9.30221 7.96274 9.30221C8.03716 9.30221 8.11158 9.30221 8.11158 9.30221C8.186 9.30221 10.7162 8.40918 10.7162 6.54872C10.7162 5.35802 9.97205 4.24174 8.85577 3.86965Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03718 11.1631C7.73951 11.1631 7.44183 11.3863 7.44183 11.7584C7.44183 12.1305 7.66509 12.3538 8.03718 12.3538C8.40927 12.3538 8.63253 12.1305 8.63253 11.7584C8.63253 11.3863 8.33486 11.1631 8.03718 11.1631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpWhite);
export default __webpack_public_path__ + "static/media/help-white.13d757333e8aba6c90a4e388fcfece0f.svg";
export { ForwardRef as ReactComponent };